import React, { useEffect, useState } from 'react';

const AddToMobileButton = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallButton, setShowInstallButton] = useState(false);
  const [isIosUser, setIsIosUser] = useState(false);

  const isIos = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test(userAgent);
  };

  const isInStandaloneMode = () =>
    'standalone' in window.navigator && window.navigator.standalone;

  useEffect(() => {
    const isIosDevice = isIos();
    const isStandalone = isInStandaloneMode();
    setIsIosUser(isIosDevice);

    // Show instructions for iOS users not in standalone mode
    if (isIosDevice && !isStandalone) {
      setShowInstallButton(true);
    }

    // Handle Android/Chrome install prompt
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallButton(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  const handleAddToHomeScreen = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();

    const { outcome } = await deferredPrompt.userChoice;
    console.log(`User response to the install prompt: ${outcome}`);

    setDeferredPrompt(null);
    setShowInstallButton(false);
  };

  if (!showInstallButton) return null;

  return (
    <div className="mt-8 md:hidden px-4">
      {isIosUser ? (
        <div className="border border-gray-400 rounded p-4 text-sm bg-white shadow">
          <p>
            To install this app on your iPhone or iPad, tap the{' '}
            <strong>Share</strong> icon on your browser, then choose{' '}
            <strong>Add to Home Screen</strong>.
          </p>
        </div>
      ) : (
        <button
          onClick={handleAddToHomeScreen}
          className="px-8 py-2 border border-gray-400 rounded bg-white shadow text-black"
        >
          Save to Phone
        </button>
      )}
    </div>
  );
};

export default AddToMobileButton;
